import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import ColleagueDashboard from './pages/ColleagueDashboard';

function ProtectedRoute({ children, requiredRole }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (requiredRole && user.role !== requiredRole)
    return <Navigate to={user.role === 'admin' ? '/admin' : '/colleague'} replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to={user.role==='admin'?'/admin':'/colleague'}/> : <Login/>}/>
      <Route path="/admin" element={<ProtectedRoute requiredRole="admin"><AdminDashboard/></ProtectedRoute>}/>
      <Route path="/colleague" element={<ProtectedRoute requiredRole="colleague"><ColleagueDashboard/></ProtectedRoute>}/>
      <Route path="*" element={<Navigate to="/login" replace/>}/>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes/>
      </BrowserRouter>
    </AuthProvider>
  );
}
